import { URL_ORDERS } from 'constants/url';
import axios from 'axios';
import { IOrder } from 'interfaces/order.interface';
import { PaginationOrders } from 'interfaces/pagination.interface';

interface GetAllOrders {
  jwt: string | null;
  pagination: PaginationOrders;
}
export interface OrdersResponse {
  orders: IOrder[];
  totalCount: number;
  totalPages: number;
}
export function getAllOrders({ jwt, pagination }: GetAllOrders): Promise<OrdersResponse> {
  const { limit, page, orderBy, order, search } = pagination;
  return new Promise((resolve, reject) => {
    axios
      .get<OrdersResponse>(
        `${URL_ORDERS}?page=${page}&limit=${limit}&orderby=${orderBy}&order=${order}&search=${search}`,
        {
          headers: {
            Authorization: `Bearer ${jwt}`
          }
        }
      )
      .then((response) => {
        if (response.status === 200) {
          resolve(response.data);
        }
      })
      .catch(() => {
        reject('Ocurrió un error, por favor contacta con soporte.');
      });
  });
}
